import { provideZoneChangeDetection } from '@angular/core';
/** Angular Imports */
import { bootstrapApplication } from '@angular/platform-browser';

/** Local Imports */
import { App } from './app/app';
import { appConfig, browserOnlyProviders } from './app/app.config';

// Merge browser-only providers (like Auth0) for client-side only
bootstrapApplication(App, {
    providers: [...(appConfig.providers || []), ...browserOnlyProviders],
}).catch((err) => console.error(err));
